































import Vue from 'vue';
import pipeline from '@/pipeline';
import PipelineMenu from '@/components/PipelineMenuWrapper.vue';
import BottomButton from '@/components/BottomButton.vue';
import BackButton from '@/components/BackButton.vue';
import AddressForm, { AddressFormEvent } from '@/components/forms/studentData/AddressForm.vue';

export default Vue.extend({
  components: {
    PipelineMenu,
    BackButton,
    AddressForm,
    BottomButton,
  },
  data() {
    return {
      addressInfo: {
        zipCode: this.$store.getters.studentAddress?.zipCode || '',
        neighborhood: this.$store.getters.studentAddress?.neighborhood || '',
        street: this.$store.getters.studentAddress?.street || '',
        number: this.$store.getters.studentAddress?.number || '',
        complement: this.$store.getters.studentAddress?.complement || '',
        state: this.$store.getters.studentAddress?.state || '',
      },
      isContinueDisabled: false,
    };
  },
  computed: {
    isContinueEnabled(): boolean {
      const { complement, ...objectValidation } = this.addressInfo;
      return Object.values(objectValidation).every(Boolean);
    },
  },
  methods: {
    inputHandler(addressForm: AddressFormEvent) {
      this.addressInfo = addressForm;
    },
    async finishHandler() {
      this.isContinueDisabled = true;
      try {
        const { addressInfo } = this;
        await this.$store.dispatch('UPDATE_ADDRESS_INFO', { addressInfo });

        pipeline.next();
      } finally {
        this.isContinueDisabled = false;
      }
    },
  },
});
